// Zero-width space placeholder. mdast's GFM task-list serializer needs a text
// child to emit an empty task marker like `* [ ]`; serializers strip it only
// from the generated empty task item body.
export const EMPTY_TASK_LIST_PLACEHOLDER = '\u200B';
